import { render } from "./SortResults.vue?vue&type=template&id=853eea5a&scoped=true"
import script from "./SortResults.vue?vue&type=script&lang=js"
export * from "./SortResults.vue?vue&type=script&lang=js"

import "./SortResults.vue?vue&type=style&index=0&id=853eea5a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853eea5a"]])

export default __exports__